define('helper-component-parseProp',['exports', './component--get-content-array.es', './component--parse-content.es'], function (exports, _componentGetContentArray, _componentParseContent) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _componentGetContentArray2 = _interopRequireDefault(_componentGetContentArray);

    var _componentParseContent2 = _interopRequireDefault(_componentParseContent);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function (content, prop, kind) {
        var res = [],
            arr = [];

        if (!content || !prop || typeof prop !== 'string' || !kind || typeof kind !== 'string' || !content.hasOwnProperty(prop)) {
            return res;
        }

        arr = (0, _componentGetContentArray2.default)(content[prop], kind);

        if (!Array.isArray(arr) || !arr.length) {
            return res;
        }

        for (var i = 0; i < arr.length; i++) {
            res.push((0, _componentParseContent2.default)(arr[i]));
        }

        return res;
    };
});
